module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-7-14e52d8ae327742d1f60bf934d3df644.jpg";